import { withIconWrapper } from '@/hocs/withIconWrapper';

import ReactComponent from './IconPennant.c.svg?react';

export const IconPennant = withIconWrapper(ReactComponent);
